import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Brand } from "@/components/common/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) return toast.error("Passwords do not match");
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="ns-grid-bg flex min-h-screen items-center justify-center bg-[#0B1120] px-4">
      <div className="ns-rise w-full max-w-md">
        <div className="mb-8 flex justify-center"><Brand /></div>
        <div className="rounded-2xl border border-[#1E2D4A] bg-[#111A2E]/80 p-7 shadow-2xl">
          <h1 className="text-xl font-bold text-slate-50">Reset password</h1>
          {!token ? (
            <p className="mt-3 text-sm text-rose-300" data-testid="reset-no-token">Invalid or missing reset link. <Link to="/login" className="text-cyan-400">Back to sign in</Link></p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-slate-300">New password</Label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="border-[#2D3F62] bg-[#0B1120] text-slate-100" data-testid="reset-password-input" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-slate-300">Confirm password</Label>
                <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="border-[#2D3F62] bg-[#0B1120] text-slate-100" data-testid="reset-confirm-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-cyan-500 to-sky-600 font-semibold text-slate-900" data-testid="reset-submit-button">
                {loading ? "Saving…" : "Set new password"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
